import type { Deal } from '@/types/deal.types';

// Def Jam user IDs for collaborators
const DJ_USERS = {
  KECIA_TATUM: 'user-9',
  NICOLE_BILLINGS: 'user-8',
  MARCUS_REYNOLDS: 'user-10',
  JEFF_HARLESTON: 'user-7',
  SASHA_ROBINSON: 'user-11',
};

export const deals: Deal[] = [
  {
    id: 'dj-deal-1',
    name: 'Coco Jones - Recording Agreement',
    type: 'Recording',
    dealType: 'music',
    stage: 'in_progress',
    value: 2500000,
    date: 'Jan 15, 2026',
    progress: 65,
    documentsCount: 10,
    collaborators: [DJ_USERS.KECIA_TATUM, DJ_USERS.NICOLE_BILLINGS],
    lastActivity: '2 hours ago',
    dueDate: 'Apr 1, 2026',
    description: 'Comprehensive recording deal covering recording, touring, merch, and publishing for 3 albums + 2 options',
  },
  {
    id: 'dj-deal-2',
    name: 'Justin Bieber - Album 7 Amendment',
    type: 'Amendment',
    dealType: 'music',
    stage: 'signing',
    value: 12000000,
    date: 'Feb 1, 2026',
    progress: 90,
    documentsCount: 6,
    collaborators: [DJ_USERS.KECIA_TATUM, DJ_USERS.JEFF_HARLESTON],
    lastActivity: '5 hours ago',
    dueDate: 'Mar 25, 2026',
    description: 'Amendment to existing recording agreement for Album 7 with updated advance and royalty terms',
  },
  {
    id: 'dj-deal-3',
    name: 'Jhene Aiko - Brand Deal',
    type: 'Brand',
    dealType: 'partnership',
    stage: 'lead',
    value: 4000000,
    date: 'Feb 10, 2026',
    progress: 20,
    documentsCount: 3,
    collaborators: [DJ_USERS.KECIA_TATUM],
    lastActivity: '3 days ago',
    dueDate: 'Jun 1, 2026',
    description: 'Brand partnership deal covering endorsements, content, and promotional appearances',
  },
  {
    id: 'dj-deal-4',
    name: 'LL Cool J - Distribution Deal',
    type: 'Distribution',
    dealType: 'music',
    stage: 'complete',
    value: 800000,
    date: 'Nov 1, 2025',
    progress: 100,
    documentsCount: 5,
    collaborators: [DJ_USERS.MARCUS_REYNOLDS],
    lastActivity: '2 weeks ago',
    dueDate: null,
    description: 'Exclusive distribution agreement for independent releases through Def Jam pipeline',
  },
  {
    id: 'dj-deal-5',
    name: 'Nasty C JV',
    type: 'Joint Venture',
    dealType: 'partnership',
    stage: 'in_progress',
    value: 3000000,
    date: 'Dec 15, 2025',
    progress: 50,
    documentsCount: 8,
    collaborators: [DJ_USERS.JEFF_HARLESTON, DJ_USERS.MARCUS_REYNOLDS],
    lastActivity: '1 day ago',
    dueDate: 'May 15, 2026',
    description: 'Joint venture sublabel with Nasty C as creative director',
  },
  {
    id: 'dj-deal-6',
    name: '2 Chainz - Nike Sync License',
    type: 'Sync License',
    dealType: 'music',
    stage: 'lead',
    value: 750000,
    date: 'Mar 1, 2026',
    progress: 15,
    documentsCount: 2,
    collaborators: [DJ_USERS.SASHA_ROBINSON],
    lastActivity: '1 day ago',
    dueDate: 'May 1, 2026',
    description: 'Sync license for 2 Chainz catalog usage in Nike Air Max campaign',
  },
  {
    id: 'dj-deal-7',
    name: 'LiAngelo Ball - Recording Agreement',
    type: 'Recording',
    dealType: 'music',
    stage: 'delivery',
    value: 13000000,
    date: 'Oct 1, 2025',
    progress: 85,
    documentsCount: 12,
    collaborators: [DJ_USERS.NICOLE_BILLINGS, DJ_USERS.KECIA_TATUM],
    lastActivity: '4 days ago',
    dueDate: 'Apr 15, 2026',
    description: 'Multi-album recording agreement with marketing commitments and brand partnership rights',
  },
  {
    id: 'dj-deal-8',
    name: 'Phil The Keys - Producer Agreement',
    type: 'Producer',
    dealType: 'music',
    stage: 'signing',
    value: 350000,
    date: 'Feb 20, 2026',
    progress: 80,
    documentsCount: 4,
    collaborators: [DJ_USERS.SASHA_ROBINSON, DJ_USERS.NICOLE_BILLINGS],
    lastActivity: '6 hours ago',
    dueDate: 'Mar 30, 2026',
    description: 'Exclusive producer agreement covering beat placements and production credits',
  },
  {
    id: 'dj-deal-9',
    name: 'Alessia Cara - Merch License',
    type: 'Merchandising',
    dealType: 'partnership',
    stage: 'lead',
    value: 200000,
    date: 'Mar 5, 2026',
    progress: 10,
    documentsCount: 1,
    collaborators: [DJ_USERS.MARCUS_REYNOLDS],
    lastActivity: '2 days ago',
    dueDate: 'Jul 1, 2026',
    description: 'Merchandise licensing agreement for tour and online retail',
  },
  {
    id: 'dj-deal-11',
    name: 'Def Jam x Kith - Brand Partnership',
    type: 'Brand',
    dealType: 'partnership',
    stage: 'lead',
    value: 5000000,
    date: 'Mar 10, 2026',
    progress: 5,
    documentsCount: 2,
    collaborators: [DJ_USERS.JEFF_HARLESTON, DJ_USERS.MARCUS_REYNOLDS],
    lastActivity: '3 hours ago',
    dueDate: 'Aug 1, 2026',
    description: 'Multi-year brand partnership for Def Jam x Kith capsule collection and artist collaborations',
  },
  {
    id: 'dj-deal-12',
    name: 'Big Sean - Catalog Buyback',
    type: 'Catalog',
    dealType: 'music',
    stage: 'in_progress',
    value: 8500000,
    date: 'Jan 5, 2026',
    progress: 55,
    documentsCount: 7,
    collaborators: [DJ_USERS.KECIA_TATUM, DJ_USERS.JEFF_HARLESTON],
    lastActivity: '12 hours ago',
    dueDate: 'May 30, 2026',
    description: 'Catalog buyback negotiation for masters from first three albums',
  },
];

/** Deals to surface in sidebar Quick Access for this org. */
export const quickAccessDeals: Array<{ dealId: string; name: string; isPinned?: boolean }> = [
  { dealId: 'dj-deal-2', name: 'Justin Bieber - Album 7 Amendment', isPinned: true },
  { dealId: 'dj-deal-7', name: 'LiAngelo Ball - Recording Agreement', isPinned: true },
  { dealId: 'dj-deal-12', name: 'Big Sean - Catalog Buyback', isPinned: true },
  { dealId: 'dj-deal-1', name: 'Coco Jones - Recording Agreement' },
  { dealId: 'dj-deal-11', name: 'Def Jam x Kith - Brand Partnership' },
  { dealId: 'dj-deal-5', name: 'Nasty C JV' },
];
